// @ts-nocheck
import * as React from 'react';
import type { CSSProperties } from 'react';

// Icon component — SVG icon renderer with icon registry.
// Lucide-style, 24×24, monoline, currentColor stroke.

const ICON_PATHS = {
  admissions: '<circle cx="9" cy="8" r="4"/><path d="M3 21v-1a6 6 0 0 1 6-6h2"/><path d="M19 12v6m-3-3h6"/>',
  fee: '<circle cx="12" cy="12" r="9"/><path d="M9 8h6M9 11h6M9 11c0 2.5 2.5 3 4 3l2 4M9 15h3"/>',
  comms: '<path d="M21 12a8 8 0 0 1-12.6 6.6L4 20l1.4-4.4A8 8 0 1 1 21 12z"/>',
  parent: '<circle cx="9" cy="8" r="4"/><path d="M3 21v-1a6 6 0 0 1 6-6"/><circle cx="17" cy="9" r="3"/><path d="M14 21v-1a4 4 0 0 1 4-4h.5"/>',
  teacher: '<path d="M3 5h6a3 3 0 0 1 3 3v12a2 2 0 0 0-2-2H3z"/><path d="M21 5h-6a3 3 0 0 0-3 3v12a2 2 0 0 1 2-2h7z"/>',
  student: '<path d="M3 9l9-4 9 4-9 4-9-4z"/><path d="M7 11v4a5 5 0 0 0 10 0v-4"/><path d="M21 9v5"/>',
  growth: '<polyline points="3 17 9 11 13 15 21 7"/><polyline points="15 7 21 7 21 13"/>',
  analytics: '<line x1="4" y1="20" x2="4" y2="10"/><line x1="10" y1="20" x2="10" y2="4"/><line x1="16" y1="20" x2="16" y2="14"/><line x1="22" y1="20" x2="2" y2="20"/>',
  voice: '<rect x="9" y="3" width="6" height="12" rx="3"/><path d="M5 11a7 7 0 0 0 14 0"/><line x1="12" y1="18" x2="12" y2="22"/>',
  language: '<circle cx="12" cy="12" r="9"/><line x1="3" y1="12" x2="21" y2="12"/><path d="M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18"/>',
  shield: '<path d="M12 3l8 3v6c0 5-3.5 8.5-8 9-4.5-.5-8-4-8-9V6z"/>',
  sparkles: '<path d="M12 3l1.8 4.5L18 9l-4.2 1.5L12 15l-1.8-4.5L6 9l4.2-1.5z"/><path d="M19 14l.9 2.1L22 17l-2.1.9L19 20l-.9-2.1L16 17l2.1-.9z"/>',
  check: '<polyline points="4 12 10 18 20 6"/>',
  eye: '<path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6-10-6-10-6z"/><circle cx="12" cy="12" r="3"/>',
  'arrow-right': '<line x1="4" y1="12" x2="20" y2="12"/><polyline points="14 6 20 12 14 18"/>',
  operations: '<path d="M3 11l9-7 9 7v9a1 1 0 0 1-1 1h-5v-7H10v7H5a1 1 0 0 1-1-1z"/>',
  command: '<rect x="3" y="3" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="9" y1="9" x2="9" y2="21"/>',
  calendar: '<rect x="3" y="5" width="18" height="16" rx="2"/><line x1="3" y1="10" x2="21" y2="10"/><line x1="8" y1="3" x2="8" y2="7"/><line x1="16" y1="3" x2="16" y2="7"/>',
  megaphone: '<path d="M3 11v2a2 2 0 0 0 2 2h2l8 5V4l-8 5H5a2 2 0 0 0-2 2z"/><path d="M19 8a4 4 0 0 1 0 8"/>',
  file: '<path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/><polyline points="14 3 14 9 20 9"/>',
  workflow: '<rect x="3" y="3" width="6" height="6" rx="1"/><rect x="15" y="15" width="6" height="6" rx="1"/><path d="M9 6h6a3 3 0 0 1 3 3v6"/>',
};

type IconName = keyof typeof ICON_PATHS;

export default function Icon({
  name,
  size = 18,
  stroke = 1.6,
  style,
}: {
  name: IconName | string;
  size?: number;
  stroke?: number;
  style?: CSSProperties;
}) {
  const inner = ICON_PATHS[name as IconName];
  if (!inner) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={style}
      dangerouslySetInnerHTML={{ __html: inner }}
    />
  );
}
